"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _ErrorApi = require("./../../../../utils/ErrorApi");

var _ErrorApi2 = _interopRequireDefault(_ErrorApi);

var _Fetch = require("./../../../../utils/Fetch");

var _Fetch2 = _interopRequireDefault(_Fetch);

var _ParamsFetch = require("./../../../../utils/ParamsFetch");

var _ParamsFetch2 = _interopRequireDefault(_ParamsFetch);

var _JsonFetch = require("./../../../../utils/JsonFetch");

var _JsonFetch2 = _interopRequireDefault(_JsonFetch);

var _generateUrl = require("./../../../../utils/generateUrl");

var _generateUrl2 = _interopRequireDefault(_generateUrl);

var _UpdateMethods = require("./../UpdateMethods");

var UpdateMethods = _interopRequireWildcard(_UpdateMethods);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Serviska pro práci s objekty. Generated from cz.marbes.api.objekt.v1.ObjektService.
 */
// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2024-05-22T17:58:34Z                      #

// ##############################################################

var ObjektApi = function () {
  function ObjektApi() {
    (0, _classCallCheck3.default)(this, ObjektApi);
  }

  (0, _createClass3.default)(ObjektApi, null, [{
    key: "findObjektFulltext",

    /**
     * Najde objekty dle předaných parametrů.
     *
     * @param query fulltextový dotaz
     * @param obec omezení hledání za kód obce
     * @param ku omezení hledání za kód katastrálního území
     * @param zaklTyp omezení hledání dle záklaního typu objektu
     * @param typ omezení hledání dle kódů typů objektů
     * @param zdroj omezení hledání na zdroj dat
     * @param max omezení počtu vrácených záznamů
     * @return nalezené objekty
     */
    value: function findObjektFulltext(query, obec, ku, zaklTyp, typ, zdroj, max) {
      var uri = serverContextPath + "/api/objekt/v1/objekty";
      var headers = undefined;
      var params = { query: query, obec: obec, ku: ku, zaklTyp: zaklTyp, typ: typ, zdroj: zdroj, max: max };

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * Najde id objektů podle id v ext systemu.
     *
     * @param extIds 
     * @param zdroj 
     * @return id objektu / id v ext systemu
     */

  }, {
    key: "findObjektIdByExtIds",
    value: function findObjektIdByExtIds(extIds, zdroj) {
      var uri = serverContextPath + ("/api/objekt/v1/objekty/objektyId/extIds/" + zdroj);
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.post(uri, params, extIds, headers));
    }

    /**
     * Vytvori objekt v lokální databázi.
     *
     * @param objektResult 
     * @return 
     */

  }, {
    key: "createObjektLocal",
    value: function createObjektLocal(objektResult) {
      var uri = serverContextPath + "/api/objekt/v1/objekty/local";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.post(uri, params, UpdateMethods.updateAbstractObjekt_09F075v1(objektResult), headers));
    }

    /**
     * Vrátí objekty podle jejich id v lokálním systému. Data o objektech jsou získány z externích systémů, nebo lokálních pokud jsou uložena pouze v databázi. Pokud jsou požadována pouze lokální data použijte {@link #findByIdIn(Collection)}.
     *
     * @param idObjektList 
     * @return 
     */

  }, {
    key: "findObjektByIds",
    value: function findObjektByIds(idObjektList) {
      var uri = serverContextPath + "/api/objekt/v1/objekty/ids";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.post(uri, params, idObjektList, headers));
    }

    /**
     * Vrátí objekt podle id. U lokálních objektů vrátí všechny data. U externích poze informace z Eobj_objekt (id v KN, popis, ...).
     *
     * @param id 
     * @return objekt
     */

  }, {
    key: "findById",
    value: function findById(id) {
      var uri = serverContextPath + ("/api/objekt/v1/objekty/" + id);
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * Najde id objektů podle id v ENO.
     *
     * @param enoIds 
     * @return id objektu / id v ENO
     */

  }, {
    key: "findObjektIdByEnoIds",
    value: function findObjektIdByEnoIds(enoIds) {
      var uri = serverContextPath + "/api/objekt/v1/objekty/objektyId/enoIds";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.post(uri, params, enoIds, headers));
    }

    /**
     * Funguje stejne jako {@link #createObjektLocal(AbstractObjekt)}. Poze se vybrane typy objektu (parcely) pokusi ztotoznit na XRN. Pokud se ztotozneni nepodari je vyhozena vyjimka.
     *
     * @param objektResult 
     * @return 
     */

  }, {
    key: "createObjektLocalZtotozneni",
    value: function createObjektLocalZtotozneni(objektResult) {
      var uri = serverContextPath + "/api/objekt/v1/objekty/localZtotozneni";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.post(uri, params, UpdateMethods.updateAbstractObjekt_09F075v1(objektResult), headers));
    }

    /**
     * Načte informace z externích systémů podle id v externím systému. Id AbstractObjekt je id v externim systemu.
     *
     * @param extIds 
     * @param zdroj 
     * @return 
     */

  }, {
    key: "findObjektInExtSystem",
    value: function findObjektInExtSystem(extIds, zdroj) {
      var uri = serverContextPath + ("/api/objekt/v1/objekty/extSystem/" + zdroj);
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.post(uri, params, extIds, headers));
    }

    /**
     * Najde id objektu podle id z KN.
     *
     * @param idKn 
     * @param typObjekt 
     * @return 
     */

  }, {
    key: "findObjektIdByKnId",
    value: function findObjektIdByKnId(idKn, typObjekt) {
      var uri = serverContextPath + "/api/objekt/v1/objekty/objektyIdByKn";
      var headers = undefined;
      var params = { idKn: idKn, typObjekt: typObjekt };

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * Aktualizuje lokalni objekt.
     *
     * @param objektInput 
     * @return 
     */

  }, {
    key: "updateObjektLocal",
    value: function updateObjektLocal(objektInput) {
      var uri = serverContextPath + "/api/objekt/v1/objekty/local";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.put(uri, params, UpdateMethods.updateAbstractObjekt_09F075v1(objektInput), headers));
    }

    /**
     * Najde zaznam o objektech podle id z katastru.
     *
     * @param idKn 
     * @param typObjekt 
     * @return 
     */

  }, {
    key: "findObjektByKn",
    value: function findObjektByKn(idKn, typObjekt) {
      var uri = serverContextPath + "/api/objekt/v1/objekty/objektByKn";
      var headers = undefined;
      var params = { idKn: idKn, typObjekt: typObjekt };

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * smaže lokální údaje o objektu.
     *
     */

  }, {
    key: "deleteObjekt",
    value: function deleteObjekt() {
      var uri = serverContextPath + "/api/objekt/v1/objekty/{id}";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.delete(uri, params));
    }

    /**
     * Načtení číselníku druhu povrchu.
     *
     * @return 
     */

  }, {
    key: "getDruhPovrchu",
    value: function getDruhPovrchu() {
      var uri = serverContextPath + "/api/objekt/v1/objekty/druhPovrchu";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * Vytvoří záznam o objektu v lokální databázi, ale data jsou v externím systému.
     *
     * @param objektResult 
     * @return 
     */

  }, {
    key: "createObjekt",
    value: function createObjekt(objektResult) {
      var uri = serverContextPath + "/api/objekt/v1/objekty";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.post(uri, params, UpdateMethods.updateObjektSearchResult_A9F268v1(objektResult), headers));
    }

    /**
     * Vrátí obsah číselníku typů objektů.
     *
     * @return typy objektů
     */

  }, {
    key: "getTypObjektu",
    value: function getTypObjektu() {
      var uri = serverContextPath + "/api/objekt/v1/objekty/typObjektu";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * Načtení číselníku typ komunikace.
     *
     * @return 
     */

  }, {
    key: "getTypKomunikace",
    value: function getTypKomunikace() {
      var uri = serverContextPath + "/api/objekt/v1/objekty/typKomunikace";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * Načtení číselníku strana komunikace.
     *
     * @return 
     */

  }, {
    key: "getStranaKomunikace",
    value: function getStranaKomunikace() {
      var uri = serverContextPath + "/api/objekt/v1/objekty/stranaKomunikace";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * Najde polohu objektu v KN.
     *
     * @param idObjektList id objektu v eobj.
     * @return 
     */

  }, {
    key: "getObjektGeometry",
    value: function getObjektGeometry(idObjektList) {
      var uri = serverContextPath + "/api/objekt/v1/objekt/poloha";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.put(uri, params, idObjektList, headers));
    }
  }]);
  return ObjektApi;
}();

exports.default = ObjektApi;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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